import { Source, Layer } from "@vis.gl/react-maplibre";

import {
  POLYGON_OPACITY,
  POLYGON_STROKE_WIDTH,
  CIRCLE_RADIUS,
} from "@/constants/map";

const PointOnMap = ({ lon, lat, color }) => {
  return (
    <Source
      type="geojson"
      data={{
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [lon, lat],
            },
            properties: {},
          },
        ],
      }}
    >
      <Layer
        type="circle"
        paint={{
          "circle-radius": CIRCLE_RADIUS,
          "circle-color": color,
          "circle-opacity": POLYGON_OPACITY,
          "circle-stroke-color": color,
          "circle-stroke-width": POLYGON_STROKE_WIDTH,
        }}
      />
    </Source>
  );
};

export default PointOnMap;
